// extracted by mini-css-extract-plugin
export default {"content":"socialLinkUpdate_content__VTNBg","collapsed":"socialLinkUpdate_collapsed__PqfZQ","Title":"socialLinkUpdate_Title__NmFc2","subTitle":"socialLinkUpdate_subTitle__UVxCX"};